module.exports = __webpack_public_path__ + "img/069-moonrise.f6305370.svg";